export default __webpack_public_path__ + "static/media/lungs_img_0003_Lungs_in_The_Air.07321aa8.png";